import {
  FaDesktop,
  FaLayerGroup,
  FaUserLock,
  FaShieldAlt,
  FaClone,
  FaCubes,
  FaRocket,
  FaChartLine,
} from "@onemind-services-llc/react-icons-ng/fa";
import SeparatorImg from "public/openStack/features/featuresSeparator.png";

export const vdiBenefits = {
  TITLE: "Key Features ",
  ITEMS: [
    {
      title: "Hosted DaaS",
      content: "Fully managed desktops provisioned over secure private cloud.",
      icon: FaDesktop,
    },
    {
      title: "Multi-Factor Authentication",
      content: "Enforce secure login across all virtual sessions.",
      icon: FaUserLock,
    },
    {
      title: "Compliance & Policy Enforcement",
      content: "Support for HIPAA, GDPR, ISO 27001, and internal IT policies.",
      icon: FaShieldAlt,
    },
    {
      title: "Persistent / Non-Persistent",
      content: "Flexibility to assign persistent desktops or use pooled VM images.",
      icon: FaClone,
    },
    {
      title: "Microsoft RDS Integration",
      content:
        "Use Microsoft RDS for secure, centralized virtual desktop delivery with policy control.",
      icon: FaLayerGroup,
    },
    {
      title: "Application Isolation",
      content: "Granular app delivery for different roles, departments, or tenants.",
      icon: FaCubes,
    },
    {
      title: "Remote Access Optimization",
      content: "Low-latency access via optimized gateways and optional GPU acceleration.",
      icon: FaRocket,
    },
    {
      title: "Centralized Management Portal",
      content: "Track usage, session health, and user policies from a single dashboard.",
      icon: FaChartLine,
    },
  ],
  SEPARATOR_IMG: SeparatorImg,
  CARD_HEIGHT: "195px",
};
